<section class="ftco-section p-5 d-flex flex-column">
    <a href="/"><img [src]="logo" alt="logo" style="width: 100px;"/></a>
    <div class="d-flex justify-content-center align-items-center w-100 h-100">
        <div class="text-center p-5 m-5 w-50 d-none d-md-block">
            <h4>Study</h4>
            <h4  [style]="style.color">Practice</h4>
            <h4>Succeed</h4>
        </div>
        <div class="w-100 w-md-50 row">
            <div class="col-md-3"></div>
            <div class="bg-light m-5 p-5 mx-auto rounded col-md-6">
                <h5 class="mb-4">Create an Account</h5>
                <p>Already have an account? <a href="/login" [style]="style.color">Sign In</a></p>           
    
                <form [formGroup]="registrationForm" (ngSubmit)="register()" class="signin-form">                            
                    <div class="form-group mb-1">
                        <label class="label" for="email">Email</label>
                        <input type="email" class="form-control" placeholder="Email" formControlName="email" required>
                    </div>
                    <div *ngIf="email.invalid && (email.dirty || email.touched)" class="text-danger text-center">
                        Email is Mandatory.
                      </div>
                    <div class="form-group mb-1">
                        <label class="label" for="password">First Name</label>
                        <input type="text" class="form-control" placeholder="First Name" formControlName="fname" required>
                    </div>
                    <div *ngIf="fname.invalid && (fname.dirty || fname.touched)" class="text-danger text-center">
                        First Name is Mandatory.
                      </div>               
                    <div class="form-group mb-1">
                        <label class="label" for="password">Last Name</label>
                        <input type="text" class="form-control" placeholder="Last Name" formControlName="lname" required>
                    </div>
                    <div *ngIf="lname.invalid && (lname.dirty || lname.touched)" class="text-danger text-center">
                        Last Name is Mandatory.
                      </div>
                    <div class="form-group mb-1">
                        <label class="label" for="password">Password</label>
                        <input type="password" class="form-control" placeholder="Password" formControlName="password" required>
                    </div>
                    <div class="form-group mb-1">
                        <label class="label" for="password">Confirm Password</label>
                        <input type="password" class="form-control" placeholder="Confirm Password" formControlName="passwordII" required>
                    </div>  
                    <div *ngIf="registrationForm.hasError('passwordMismatch')" class="text-danger text-center">
                        Passwords do not match.
                      </div>
                    <div class="form-group mb-1">
                        <label class="label" for="password">Phone</label>
                        <input type="text" class="form-control" placeholder="Phone" formControlName="phone" required>
                    </div>   
                    <div *ngIf="phone.invalid && (phone.dirty || phone.touched)" class="text-danger text-center">
                        Phone Number is Mandatory.<br>
                        Must be 11 numerical digits.
                      </div>       
                    <div class="form-group">
                        <button type="submit" [style]="style.btnstyle" class="w-100 submit px-3 mt-5" [disabled]="registrationForm.invalid || loading">
                            <i class="fa fa-spinner spin-icon spinner" style="font-size: large ;" *ngIf="loading"></i>
                            Sign Up
                        </button>
                    </div>
                    <div class="form-group d-md-flex">
                        <div class="w-50 text-left">                                  
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-md-3"></div>
        </div>        
    </div>
</section>
